<template>
  <div class="aimoxingyucanshu-page">
    <div class="header">
      <div class="logo">
        <div class="icon">
          <img src="@/assets/aimoxingyucanshu/icon.png" alt="AI模型选择与参数配置">
        </div>
        <h1>金融模型选择与参数配置</h1>
        <div style="display:none;" @click="runAudio">隐藏播放音频按钮</div>
      </div>
      <div class="model-select">
        选择金融模型
      </div>
      <div class="tabs">
        <button v-for="tab in tabs" :key="tab.key" :class="['tab-btn', { active: activeTab === tab.key }]"
                :id="'btn-tab-' + tab.key" @click="handleClickTab(tab.key)">
          {{ tab.name }}
          <span v-if="tab.key === recommendedModelKey" class="recommended-badge">主推</span>
        </button>
      </div>

      <div class="ai-tip">
        <i class="el-icon-info ai-tip-icon"></i>
        <div class="ai-tip-body">
          <div class="ai-tip-desc">
            您可调整右侧参数，参数将同时展示模型的理论最优组合（不考虑约束）与合规裁剪后的实际推荐组合（受风险等级等约束）。
          </div>
          <div class="ai-tip-action-row">
            <div class="calc-logic-btn" @click="handleCalcLogic"><i class="el-icon-s-opportunity"></i>计算逻辑</div>
            <span class="ai-tip-action-desc">用于查看通俗说明、数学公式与技术脚本</span>
          </div>
        </div>
      </div>
    </div>

    <div class="content">
      <Model ref="modelComponent" :activeTab="activeTab"></Model>
    </div>

    <div class="footer">
      <button class="confirm-btn common-btn" id="btn-confirm-params" @click="handleConfirm">
        <svg width="24" height="24" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M24 44C29.5228 44 34.5228 41.7614 38.1421 38.1421C41.7614 34.5228 44 29.5228 44 24C44 18.4772 41.7614 13.4772 38.1421 9.85786C34.5228 6.23858 29.5228 4 24 4C18.4772 4 13.4772 6.23858 9.85786 9.85786C6.23858 13.4772 4 18.4772 4 24C4 29.5228 6.23858 34.5228 9.85786 38.1421C13.4772 41.7614 18.4772 44 24 44Z"
                fill="none" stroke="#fff" stroke-width="4" stroke-linejoin="round" />
          <path d="M16 24L22 30L34 18" stroke="#fff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <span style="margin-left: 8px;">确认参数并生成推荐</span>
      </button>
    </div>
  </div>
</template>

<script>
import Model from './components/model.vue'

export default {
  name: 'AiMoxingYuCanshuPage',
  components: {
    Model,
  },
  data () {
    return {
      activeTab: 'MeanVariance',
      tabs: [
        { key: 'MeanVariance', name: '马科维茨均值-方差模型' },
        { key: 'RiskParity', name: '风险平价模型' },
        { key: 'MinVariance', name: '最小方差模型' },
        { key: 'BlackLitterman', name: '贝叶斯均值方差模型' },
        { key: 'EqualWeight', name: '等权 1/N模型' },
      ]
    }
  },
  created () {
    this.runAudio()
    const savedTab = localStorage.getItem('activeModelTab')
    if (savedTab) {
      this.activeTab = savedTab
    } else {
      this.activeTab = this.recommendedModelKey || 'MeanVariance'
    }
  },
  mounted () {
    window.addEventListener('storage', this.handleStorageChange)
  },
  beforeDestroy () {
    window.removeEventListener('storage', this.handleStorageChange)
  },
  computed: {
    recommendedModelKey () {
      const riskResultStr = localStorage.getItem('riskResult')
      if (!riskResultStr) return ''
      try {
        const riskResult = JSON.parse(riskResultStr)
        const map = {
          C1: 'MinVariance',
          C2: 'RiskParity',
          C3: 'MeanVariance',
          C4: 'BlackLitterman',
          C5: 'MeanVariance'
        }
        return map[riskResult.type] || ''
      } catch (e) {
        return ''
      }
    }
  },
  methods: {
    runAudio () {
      this.playOnceAudio('/开始金融模型选择与参数配置.mp3')
    },
    handleCalcLogic () {
      console.log('[handleCalcLogic] activeTab:', this.activeTab)
      this.$router.push({ name: 'Jisuanluoji', query: { model: this.activeTab } })
    },
    handleClickTab (tabKey) {
      this.activeTab = tabKey
      localStorage.setItem('activeModelTab', tabKey)
    },
    handleStorageChange (event) {
      if (event.key === 'activeModelTab') {
        this.activeTab = event.newValue
      }
    },
    handleConfirm () {
      this.$refs.modelComponent.confirmMakeweiciParameters()
    }
  }
}
</script>

<style scoped lang="less">
.aimoxingyucanshu-page {
  min-height: 100vh;
  background: url('../../assets/bg-hp.png') no-repeat;
  background-size: 100% 100%;
  padding: 20px 40px;
  box-sizing: border-box;
}

.header {
  margin-bottom: 32px;
}

.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.logo i {
  font-size: 24px;
  color: #3b82f6;
}

.logo h1 {
  font-size: 24px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.icon {
  width: 36px;
  height: 36px;
  background: #486dff;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 24px;
    height: 24px;
    object-fit: cover;
  }
}

.model-select {
  font-size: 18px;
  font-weight: 600;
  color: #155DFC;
  margin-bottom: 12px;
}

.tabs {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

.tab-btn {
  padding: 12px 24px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: white;
  font-size: 14px;
  color: #272e4d;
  cursor: pointer;
  transition: all 0.3s ease;
}

.tab-btn:hover {
  border-color: #3b82f6;
  color: #3b82f6;
}

.tab-btn.active {
  background: #3b82f6;
  border-color: #3b82f6;
  color: white;
}

.recommended-badge {
  display: inline-block;
  margin-left: 5px;
  padding: 1px 6px;
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(135deg, #f59e0b 0%, #ef4444 100%);
  border-radius: 8px;
  vertical-align: super;
  line-height: 1.4;
  animation: badgePulse 2s ease-in-out infinite;
}

@keyframes badgePulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.75;
  }
}

.ai-tip {
  display: flex;
  // align-items: flex-start;
  align-items: center;
  gap: 10px;
  padding: 16px 20px;
  background: #dbeafe;
  border-radius: 10px;
  color: #1e40af;
  margin-bottom: 0px;
}

.ai-tip-icon {
  font-size: 16px;
  margin-top: 2px;
  color: #3b82f6;
  flex-shrink: 0;
}

.ai-tip-body {
  flex: 1;
  min-width: 0;
  display: flex;
  // flex-direction: column;
  align-items: center;
  gap: 0px;
}

.ai-tip-desc {
  font-size: 13px;
  line-height: 1.65;
  color: #1e40af;
  text-align: left;
}

.ai-tip-action-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.ai-tip-action-desc {
  font-size: 13px;
  line-height: 1.65;
  color: #1e40af;
}

.calc-logic-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  padding: 7px 16px;
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 2px 6px rgba(59, 130, 246, 0.2);
  user-select: none;
  white-space: nowrap;
}

.calc-logic-btn i {
  font-size: 14px;
  color: #fff;
  margin-top: 0;
}

.calc-logic-btn:hover {
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.35);
  transform: translateY(-1px);
}

.calc-logic-btn:active {
  transform: translateY(0);
  box-shadow: 0 1px 4px rgba(59, 130, 246, 0.2);
}

.content {
  margin-bottom: 32px;
}

.footer {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 32px;
  padding-top: 24px;
}

.confirm-btn {
  width: 300px;
  font-size: 18px;
}

.confirm-btn i {
  font-size: 16px;
}

/* 横屏适配 */
@media screen and (orientation: landscape) and (max-width: 1366px) {
  .aimoxingyucanshu-page {
    padding: 20px 40px;
  }

  .header {
    margin-bottom: 12px;
  }

  .logo h1 {
    font-size: 28px;
  }

  .logo i {
    font-size: 28px;
  }

  .model-select {
    font-size: 16px;
    margin-bottom: 6px;
  }

  .tab-btn {
    padding: 7px 14px;
    font-size: 16px;
  }

  .ai-tip {
    padding: 14px 20px;
    margin-bottom: 6px;
  }

  .ai-tip-desc,
  .ai-tip-action-desc {
    font-size: 13px;
  }

  .confirm-btn {
    padding: 14px 28px;
    font-size: 18px;
  }

  .confirm-btn i {
    font-size: 18px;
  }

  .content {
    margin-bottom: 6px;
  }

  .footer {
    margin-top: 0px;
    padding-top: 8px;
  }
}

/* 竖屏适配 */
@media screen and (orientation: portrait) {
  .aimoxingyucanshu-page {
    padding: 20px 16px;
    min-height: 100vh;
    background: url('../../assets/bg-sp.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 8px;
  }

  .header {
    margin-bottom: 0;
    text-align: center;
  }

  .logo {
    gap: 8px;
    margin-bottom: 0;
  }

  .icon {
    width: 40px;
    height: 40px;
  }

  .icon img {
    width: 28px;
    height: 28px;
  }

  .logo h1 {
    font-size: 18px;
    font-weight: 700;
    letter-spacing: 0.5px;
    margin: 0;
  }

  .ai-tip-body {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0px;
  }

  .model-select {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 12px;
  }

  .tabs {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 8px;
    margin-bottom: 12px;
  }

  .tab-btn {
    min-width: 0;
    padding: 10px 12px;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 500;
    background: white;
    border: 2px solid #e2e8f0;
    color: #64748b;
    transition: all 0.2s ease;
  }

  .tab-btn:nth-child(-n+3) {
    grid-column: span 2;
  }

  .tab-btn:nth-child(n+4) {
    grid-column: span 3;
  }

  .tab-btn:hover {
    transform: translateY(-1px);
  }

  .recommended-badge {
    font-size: 9px;
    padding: 0 4px;
    margin-left: 3px;
  }

  .ai-tip {
    padding: 10px 14px;
    background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
    border-radius: 10px;
    margin-bottom: 0;
  }

  .ai-tip-desc {
    font-size: 12px;
    line-height: 1.55;
  }

  .ai-tip-action-row {
    gap: 6px;
  }

  .ai-tip-action-desc {
    font-size: 11px;
  }

  .calc-logic-btn {
    font-size: 12px;
    padding: 6px 14px;
  }

  .content {
    margin-bottom: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .footer {
    display: none;
    flex-direction: column;
    gap: 12px;
    margin-top: 0;
    padding-top: 0;
  }

  .confirm-btn {
    display: none;
    width: 100%;
    padding: 14px;
    font-size: 15px;
    font-weight: 600;
    border-radius: 12px;
    border: none;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    letter-spacing: 0.5px;
    position: relative;
    overflow: hidden;
  }

  .confirm-btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s ease;
  }

  .confirm-btn:hover::before {
    left: 100%;
  }

  .confirm-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(99, 102, 241, 0.45);
  }

  .confirm-btn i {
    font-size: 14px;
  }
}

/* 小屏幕适配 */
@media (max-width: 768px) {
  .aimoxingyucanshu-page {
    padding: 16px;
  }

  .logo h1 {
    font-size: 18px;
  }

  .logo i {
    font-size: 18px;
  }

  .tab-btn {
    padding: 10px 20px;
    font-size: 14px;
  }

  .ai-tip {
    padding: 10px 12px;
  }

  .ai-tip-desc {
    font-size: 11px;
  }

  .ai-tip-action-row {
    // flex-direction: column;
    align-items: center;
    gap: 5px;
  }

  .ai-tip-action-desc {
    font-size: 11px;
  }

  .calc-logic-btn {
    font-size: 11px;
    padding: 5px 12px;
  }

  .footer {
    flex-direction: column;
    gap: 12px;
  }

  .confirm-btn {
    padding: 12px 24px;
    font-size: 16px;
    width: 100%;
    justify-content: center;
  }

  .confirm-btn i {
    font-size: 16px;
  }
}
</style>
